import { __ } from "@wordpress/i18n";

const features = [
    "Comparable two image slider",
    "Comparable three image slider",
    "Comparable video slider",
    "Image size settings",
    "Indicator Image",
    "Divider offset",
    "Slider trigger type",
    "Slider orientation",
    "8 slider templates",
    "Slider Popup",
    "Slider elementor widget",
    "Slider overlay customization",
    "Slider handle customization",
    "Slider divider customization",
    "Slider label customization",
];

// Get plugin URL from global variable with fallback
const pluginUrl = window.cocaBaisDashboard?.pluginUrl || "";

// Define image paths with fallbacks - avoiding any undefined property access
const getImagePath = (imageName) => {
    // Try multiple paths to find the working one
    const paths = [
        // Path 1: Direct from plugin URL to assets/lib/images
        pluginUrl + "assets/lib/images/" + imageName + ".png",
        // Path 2: src/lib/images path
        pluginUrl + "src/lib/images/" + imageName + ".png",
    ];
    // Return the first non-empty path
    return paths.find((path) => path && path.length > 0) || "";
};

const getImagePathSvg = (imageName) => {
    // Try multiple paths to find the working one
    const paths = [
        // Path 1: Direct from plugin URL to assets/lib/images
        pluginUrl + "assets/lib/images/" + imageName + ".svg",
        // Path 2:  src/lib/images path
        pluginUrl + "src/lib/images/" + imageName + ".svg",
    ];
    // Return the first non-empty path
    return paths.find((path) => path && path.length > 0) || "";
};

const FeatureSection = () => {
    return (
        <section className="coca__feature-section">
            <div className="container">
                <div className="feature-wrapper">
                    <div className="feature-image">
                        <img src={getImagePath("feature-image")} alt="Before After Comparison" />
                    </div>
                    <div className="feature-content">
                        <h2>
                            WP Before After <br />
                            Image Slider Features
                        </h2>
                        <p>
                            You can explore the features that we provide with fun and have their own functions each
                            feature.
                        </p>
                        <ul>
                            {features.map((feature, idx) => (
                                <li key={idx}>
                                    <span>{feature}</span>
                                    <span className="checkmark">✔</span>
                                </li>
                            ))}
                        </ul>
                        <a
                            href="https://codecanel.com/wp-before-after-image-slider/#product-pricing"
                            className="pro-button"
                            target="_blank"
                        >
                            <img src={getImagePathSvg("premium-icon")} alt="Premium Icon" /> Get Started Pro
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FeatureSection;
